"use client";

import {forwardRef, useRef} from "react";
import ChatInputDictationProvider from "./chat-input/ChatInputDictationProvider";
import ChatInputBase from "./chat-input/ChatInputBase";
import type {ChatInputHandle, ChatInputProps} from "./chat-input/types";

export type {ChatInputHandle, ChatInputProps};

const ChatInput = forwardRef<ChatInputHandle, ChatInputProps>((props, ref) => {
   const inputRef = useRef<HTMLTextAreaElement>(null);

   if (!props.enableDictation) {
      return <ChatInputBase {...props} ref={ref} inputRef={inputRef} dictation={null} />;
   }

   return (
      <ChatInputDictationProvider
         value={props.value}
         onChange={props.onChange}
         disabled={props.disabled}
         inputRef={inputRef}
      >
         {(dictation) => (
            <ChatInputBase {...props} ref={ref} inputRef={inputRef} dictation={dictation} />
         )}
      </ChatInputDictationProvider>
   );
});

ChatInput.displayName = "ChatInput";

export default ChatInput;
